import { render } from "./SchedulesDetailsBody.vue?vue&type=template&id=774b4c98&scoped=true"
import script from "./SchedulesDetailsBody.vue?vue&type=script&lang=js"
export * from "./SchedulesDetailsBody.vue?vue&type=script&lang=js"

import "./SchedulesDetailsBody.vue?vue&type=style&index=0&id=774b4c98&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774b4c98"]])

export default __exports__
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTabPanel,QTabPanels});
